import { useState } from "react";
import { tags } from "@models/constants";
import { translate } from "@locales";

function useTags({ items, setSearchBytags }) {
  const [selectedTag, setSelectedTag] = useState("");

  function handleClick(tag) {
    if (selectedTag === tag) {
      setSelectedTag("");
      setSearchBytags([]);
    } else {
      setSelectedTag(tag);
      const searchBytags = items.filter((item) => item["tags"].includes(tag));
      setSearchBytags(searchBytags);
    }
  }

  return {
    models: {
      selectedTag,
    },
    operations: {
      handleClick,
    },
  };
}

export function Tags({ items, setSearchBytags }) {
  const { models, operations } = useTags({ items, setSearchBytags });

  return (
    <div className="">
      <div className="flex justify-center">
        <div className="flex justify-center ">
          <div className="flex flex-col">
            <span className="mb-[13px]">{translate("educational.tags")}</span>
            <div className="flex pb-3 flex-row justify-between overflow-x-auto w-[335px] lg:w-[743px] space-x-4 static-scrollbar">
              <>
                {tags.map((tag) => (
                  <button
                    className={`whitespace-nowrap border-solid border font-chivo-regular uppercase tracking-[1.3px] w-full h-[36px] text-center text-sm p-2 border-dark-gray ${
                      models.selectedTag === tag
                        ? "text-white bg-black"
                        : "text-dark-gray bg-white"
                    }`}
                    onClick={() => operations.handleClick(tag)}
                    key={tag}
                  >
                    #{tag}
                  </button>
                ))}
              </>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
